import {Component, importProvidersFrom, OnInit, ChangeDetectionStrategy} from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { environment } from "../../../environments/environment";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { classicUrl } from "../../../assets/classic-url";
import {MatIconModule} from "@angular/material/icon";
import {MsalModule} from "@azure/msal-angular";
import { Router } from "@angular/router";
@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    standalone: true,
    imports: [
        MatIconModule
    ],
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
  messageTest: string = '';
  htmlError: string = '';
  url: SafeResourceUrl;
  urlBase: string = '';
  envToKeyMap = {
    local: 'Local',
    dev: 'Dev',
    test: 'Test',
    prod: 'Prod'
  };
  constructor(
    private authService: AuthService, private sanitizer: DomSanitizer, private router: Router
  ) {
    this.urlBase = classicUrl[this.envToKeyMap[environment.name] as keyof typeof classicUrl];
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlBase);
  }

  ngOnInit() {
    window.addEventListener('message', (event) => {
      const data = event.data;

      if (data?.type === 'open-message' && data.messageId) {
        this.router.navigate(['/trafikinfo', data.messageId]);
      }
    });
  }

  getUser() {
    return "User info:\n" + this.authService.getActiveAccount();
  }

  goToToT() {
    if (environment.development) {
      window.open(classicUrl.Dev, "_blank")
    }
    else if (environment.test) {
      window.open(classicUrl.Test, "_blank")
    }
    else if (environment.production) {
      window.open(classicUrl.Prod, "_blank")
    }
    else {
      window.open(classicUrl.Dev, "_blank")
    }
  }

  navigateToWebsite() {
    if (environment.development) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(classicUrl.Dev);
    }
    else if (environment.test) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(classicUrl.Test);
    }
    else if (environment.production) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(classicUrl.Prod);
    }
    else {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(classicUrl.Dev);
    }
  }
}
